"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerWithVersion = exports.Signer = void 0;
const address_1 = require("../address");
const common_1 = require("../common");
class Signer {
    constructor(key, url) {
        this.key = key;
        this.url = url;
    }
    static forPage(url, key) {
        return new Signer(key, address_1.URL.parse(url));
    }
    static forLite(key) {
        const keyStr = common_1.Buffer.from(key.address.publicKeyHash.slice(0, 20)).toString("hex");
        const checkSum = (0, common_1.sha256)(common_1.Buffer.from(keyStr, "utf-8"));
        const checkStr = common_1.Buffer.from(checkSum.slice(28)).toString("hex");
        const url = address_1.URL.parse(keyStr + checkStr);
        return new SignerWithVersion(key, url, 1);
    }
    sign(message, opts) {
        return this.key.sign(message, {
            ...opts,
            signer: this.url,
        });
    }
    withVersion(version) {
        return new SignerWithVersion(this.key, this.url, version);
    }
}
exports.Signer = Signer;
class SignerWithVersion extends Signer {
    constructor(key, url, version) {
        super(key, url);
        this.version = version;
    }
    sign(message, opts) {
        return this.key.sign(message, {
            ...opts,
            signer: this.url,
            signerVersion: this.version,
        });
    }
}
exports.SignerWithVersion = SignerWithVersion;
//# sourceMappingURL=signer.js.map